module.exports = __webpack_public_path__ + "img/p161_reset.eab9e2da.png";